// axios
import axios from 'axios'
import store from './store/store'
import router from './router'

const baseURL = process.env.VUE_APP_API_HOST;

let axiosInstance = axios.create({
	baseURL,
	headers: {
		Authorization: "Bearer "+ store.state.auth.token,
	},
});

axiosInstance.interceptors.request.use(function(config) {
	let param = `language=${store.state.locale}`;

	if(config.url.indexOf('?') === -1) {
		config.url += '?' + param;
	} else {
		config.url += '&' + param;
	}

	const isFormData = typeof FormData !== 'undefined' && config.data instanceof FormData;
	config.headers = config.headers || {};

	if (store.state.auth.token) {
		config.headers.Authorization = `Bearer ${store.state.auth.token}`;
	}

	if (isFormData) {
		// Let the browser set multipart/form-data with boundary
		delete config.headers['Content-Type'];
		delete config.headers['content-type'];
		if (config.headers.common) {
			delete config.headers.common['Content-Type'];
			delete config.headers.common['content-type'];
		}
		if (config.headers.post) {
			delete config.headers.post['Content-Type'];
			delete config.headers.post['content-type'];
		}
	} else if (!config.headers['Content-Type'] && !config.headers['content-type']) {
		config.headers['Content-Type'] = 'application/json';
	}

	return config;
})

axiosInstance.interceptors.response.use((response) => response, (error) => {
	if (error.response.status === 401) {
		localStorage.removeItem('token')
		localStorage.removeItem('layout')
		localStorage.removeItem('role')
		store.dispatch('logout')
		router.push('/login')
	}
	throw error;
});

export default axiosInstance;
